import {ChangeDetectionStrategy, Component, inject, ViewEncapsulation} from '@angular/core';
import {MyPagesService} from '../../services/my-pages.service';
import {BankidService} from '../../services/bankid.service';
import {SidebarNavService} from './sidebar-nav.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {RoutesAddonsEnums, RoutesEnums, RoutesNamesEnum} from '../../enums/RoutesEnums';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarNavComponent {
  protected readonly RoutesNamesEnum = RoutesNamesEnum;
  protected readonly RoutesAddonsEnums = RoutesAddonsEnums;
  protected readonly RoutesEnums = RoutesEnums;
  private myPagesService = inject(MyPagesService);
  public profile = toSignal(this.myPagesService.profile$);

  constructor(
    private sidebarNavService: SidebarNavService,
    private bankIdService: BankidService,
    private router: Router,
  ) {}

  protected closeMenu() {
    this.sidebarNavService.closeSidebarNav();
  }

  protected onLogout() {
    this.bankIdService.logout().subscribe(() => {
      window.location.href = '/';
    });
  }
}
